<template>
  <div class="relative flex-shrink-0 flex h-auto py-1 md:py-4 z-20">
    <popup
      :opened="avisPopupState > -1"
      @close="avisPopupState = -1"
    >
      <!-- BEGIN Content modal add referent -->
      <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
        <div v-if="avisPopupState === 1">
          <h3 class="mb-10">
            Donner votre avis
          </h3>
          <h6 class="w-full text-center text-indigo-600 mb-10">
            Vous pouvez nous faire part de vos remarques ou suggestions ici,
            afin d'améliorer votre expérience utilisateur.
          </h6>

          <form
            class="grid grid-cols-2 gap-x-4 gap-y-10 mb-10"
            autocomplete="off"
          >
            <input-text
              name="Prénom"
              class="md:col-span-1"
              libelle="Prénom"
              :value="formAvis.firstname"
              @input="
                (newValue) => {
                  formAvis.firstname = newValue;
                }
              "
            />
            <input-text
              name="Nom"
              class="md:col-span-1"
              libelle="Nom"
              :value="formAvis.lastname"
              @input="
                (newValue) => {
                  formAvis.lastname = newValue;
                }
              "
            />
            <input-text
              class="md:col-span-1"
              libelle="Email"
              :value="formAvis.email"
              @input="
                (newValue) => {
                  formAvis.email = newValue;
                }
              "
            />
            <input-text
              class="md:col-span-1"
              libelle="Téléphone"
              :value="formAvis.phone"
              @input="
                (newValue) => {
                  formAvis.phone = newValue;
                }
              "
              type="tel"
              :error="true"
            />
            <input-text-area
              class="md:col-span-full"
              libelle="Votre avis"
              :value="formAvis.commentary"
              @input="
                (newValue) => {
                  formAvis.commentary = newValue;
                }
              "
            />

            <!-- display errors -->
          </form>

          <div class="flex justify-center">
            <action-button
              border-color="border-transparent"
              text-color="text-white"
              bg-color="bg-pink-600"
              bg-color-square="bg-pink-600"
              icon-color="text-white"
              libelle="Envoyer"
              :uppercase="true"
              :spinner="sending"
              icon="plane"
              :right="true"
              type-shadow="shadow-pink"
              @clickAction="!sending ? sendAvis() : null"
            />
          </div>
        </div>
        <div v-if="avisPopupState === 2">
          <h3 class="mb-10">
            Votre avis a été envoyé
          </h3>

          <div class="flex flex-col space-y-5 items-center">
            <h6 class="text-indigo-600">
              Merci d'avoir pris le temps de nous faire part de votre retour.
            </h6>
            <illustration name="basket" />
          </div>
        </div>
      </div>
    </popup>

    <!-- BEGIN hamburger menu for mobile devices -->
    <button
      class="ml-6 lg:ml-12 text-indigo-600 focus:outline-none xl:hidden"
      aria-label="Open sidebar"
      @click="openSidebar()"
    >
      <icon
        name="menu"
        class="text-indigo-600 w-5 h-5 lg:w-6 lg:h-6"
      />
    </button>
    <!-- END hamburger menu for mobile devices -->

    <div class="flex flex-1 px-2 md:px-4">
      <div class="flex w-8/12 ml-10 text-pink-600 text-lg items-center">
        <banner
          class="hidden lg:block"
          v-if="
            ((($trial() &&
              !$subscription() &&
              [
                constants.ROLE_ADMIN_PAYEUR,
                constants.ROLE_ADMIN_ENTREPRISE,
              ].includes(role)) ||
              $freeParticulier()) &&
              currentPage === '/') ||
              isInCompetencesModule
          "
        >
          <!-- BEGIN Message if not subscription / trial period -->
          <TrialPeriodMessage />
          <!-- END Message if not subscription / trial period -->

          <!-- BEGIN Message if Particulier User -->
          <div v-if="$freeParticulier()">
            <p>
              Vous êtes actuellement sur une version
              <span class="uppercase font-semibold">bêta</span>
              qui va évoluer prochainement.
            </p>
            <p>
              Vos retours sont précieux, n'hésitez pas à nous faire part de
              votre
              <span class="font-semibold">avis</span>
              <span
                class="underline text-pink-600 cursor-pointer hover:font-semibold"
                @click="displayAvisPopup"
              >ici</span>.
            </p>
          </div>
          <!-- END Message if Particulier User -->

          <!-- BEGIN Message in Competences module page -->
          <div v-if="isInCompetencesModule">
            <p>
              Le module Compétences est actuellement sur une version
              <span class="uppercase font-semibold">bêta</span>
              qui va évoluer prochainement.
            </p>
            <p>
              Vos retours sont précieux, n'hésitez pas à nous faire part de
              votre
              <span class="font-semibold">avis</span>
              <span
                class="underline text-pink-600 cursor-pointer hover:font-semibold"
                @click="displayAvisPopup"
              >ici</span>.
            </p>
          </div>
          <!-- END Message in Competences module page -->
        </banner>
      </div>

      <div class="w-1/3 md:w-1/5 flex items-center justify-evenly">
        <button
          v-if="$can('messagerie')"
          class="relative p-1 text-indigo-600 rounded-full focus:outline-none tour_messages"
          aria-label="Messages"
        >
          <icon
            name="email"
            class="h-8 w-8"
          />
          <span
            class="absolute top-0 right-0 block h-4 w-4 rounded-full text-xs text-white bg-pink-600"
          >3</span>
        </button>

        <button
          v-if="$can('notifications')"
          class="relative p-1 text-indigo-600 rounded-full focus:outline-none tour_notifs"
          aria-label="Notifications"
        >
          <icon
            name="bell"
            class="h-8 w-8"
          />
          <span
            class="absolute top-0 right-0 block h-4 w-4 rounded-full text-xs text-white bg-pink-600"
          >1</span>
        </button>
      </div>
      <div class="flex items-center justify-start mr-10 w-max">
        <!-- Profile dropdown -->
        <div class="relative">
          <button
            class="flex items-center text-left text-2sm rounded-full focus:outline-none"
            id="user-menu"
            aria-label="User menu"
            aria-haspopup="true"
            @click="toggle"
            @click.stop
          >
            <profile-picture size="max-w-10 w-10 h-10" />
            <div class="hidden md:block mx-3">
              <p class="text-lg leading-5 font-normal text-gray-900">
                {{ user.firstname }}
                <span class="uppercase">{{ user.lastname }}</span>
              </p>
            </div>
            <div class="hidden md:block">
              <icon
                v-if="!userMenu"
                class="text-pink-600"
                name="chevron-down"
              />
              <icon
                v-else
                class="text-pink-600"
                name="chevron-up"
              />
            </div>
          </button>

          <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <div
              class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg w-max-content w-max"
              v-show="userMenu"
            >
              <div
                class="w-auto py-4 rounded-2xl bg-white"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
                v-click-outside="close"
                @click="close"
              >
                <router-link
                  v-if="
                    $can(
                      constants.PERMISSION_PARAMETRE_COMPTE_INFORMATIONS_COMPTE
                    )
                  "
                  :to="{ name: 'Accountinformations' }"
                  class="block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150"
                  role="menuitem"
                >
                  Paramètres de compte
                </router-link>
                <router-link
                  v-if="$freeParticulier()"
                  :to="{ name: 'PermissionsGuests' }"
                  class="block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150"
                  role="menuitem"
                >
                  Gestion des invités
                </router-link>
                <router-link
                  v-if="
                    ($can(constants.PERMISSION_GESTION_DROITS_ROLE_LISTE) ||
                      $can(
                        constants.PERMISSION_GESTION_DROITS_REFERENT_LISTE
                      ) ||
                      $can(
                        constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_LISTE
                      ))
                  "
                  :to="{ name: 'Permissions' }"
                  class="block px-6 py-2 font-normal text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150"
                  role="menuitem"
                >
                  Gestion, droits et restrictions
                </router-link>
                <button
                  @click="logout"
                  class="block w-full px-6 py-2 font-normal text-left text-base text-gray-600 hover:bg-indigo-600 hover:text-white transition ease-in-out duration-150"
                  role="menuitem"
                >
                  Déconnexion
                </button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Constants from './../constants';
import ClickOutside from 'vue-click-outside';
import Icon from './Icon';
import Popup from './Popup.vue';
import InputText from './Inputs/InputText.vue';
import InputTextArea from './Inputs/InputTextArea.vue';
import ActionButton from './ActionButton.vue';
import axios from 'axios';
import Illustration from './Illustration.vue';
import Banner from './Banner.vue';
import ProfilePicture from './ProfilePicture.vue';
import TrialPeriodMessage from './TrialPeriodMessage.vue';

export default {
  props: {
    isOpen: Boolean,
  },

  components: {
    TrialPeriodMessage,
    ProfilePicture,
    Icon,
    Popup,
    InputText,
    InputTextArea,
    ActionButton,
    Illustration,
    Banner,
  },

  data() {
    return {
      userMenu: false,
      search: '',
      avisPopupState: -1,
      sending: false,

      formAvis: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        commentary: '',
      },
      constants: Constants,
    };
  },

  mounted() {
    this.formAvis.firstname = this.user.firstname;
    this.formAvis.lastname = this.user.lastname;
    this.formAvis.email = this.user.email;
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      structure: 'auth/structure',
      role: 'auth/role',
    }),


    currentPage() {
      return this.$route.path;
    },

    isInCompetencesModule() {
      return this.currentPage === '/competences';
    },
  },

  methods: {
    ...mapActions({
      logoutAction: 'auth/logout',
    }),

    async logout() {
      try {
        await this.logoutAction();
        this.$router.go('/login');
      } catch (error) {
        console.error('Une erreur c\'est produite');
      }
    },

    openSidebar() {
      this.$emit('open');
    },

    toggle() {
      this.userMenu = !this.userMenu;
    },

    close() {
      if (this.userMenu === true) {
        this.userMenu = false;
      }
    },

    displayAvisPopup() {
      this.avisPopupState = 1;
    },

    async sendAvis() {
      this.sending = true;
      await axios
        .post('api/users/sendAvis', this.formAvis)
        .then((response) => {
          this.sending = false;
          this.avisPopupState = 2;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
